import {CustomCellRendererProps} from '@ag-grid-community/react';
import {IconBan, IconBuildingBroadcastTower, IconCloudBolt, IconDeer, IconRoad} from "@tabler/icons-react";
import {Group} from "@mantine/core";
import {RestrictionEntity, restrictionType} from "@ots-frontend/ots-data";
import {ReactElement} from "react";

export type LocationData = {
  name?: string;
  nonDefaultStage?: boolean
  restrictions?: RestrictionEntity[]
}

export type LocationCellProps = CustomCellRendererProps<LocationData> & {}

export const LocationCell = (props: LocationCellProps) => {
  const {value} = props

  if (!value || !value.name) {
    return undefined
  }

  if (!value.nonDefaultStage && (!value.restrictions || value.restrictions.length === 0)) {
    return value.name
  }

  let restrictionIcon: ReactElement | undefined = undefined
  if (value.restrictions && value.restrictions.length > 0) {
    restrictionIcon = <IconBan size={14} color="orange"/>

    if (value.restrictions.every((e: RestrictionEntity) => e.type === restrictionType.hunting)) {
      restrictionIcon = <IconDeer size={14} color="orange" />
    } else if (value.restrictions.every((e: RestrictionEntity) => e.type === restrictionType.weather)) {
      restrictionIcon = <IconCloudBolt size={14} color="orange"/>
    } else if (value.restrictions.every((e: RestrictionEntity) => e.type === restrictionType.road)) {
      restrictionIcon = <IconRoad size={14} color="orange"/>
    }
  }

  return (
    <Group spacing="xs">
      {value.nonDefaultStage && <IconBuildingBroadcastTower size={14} color="orange" /> }
      {restrictionIcon}
      {value.name}
    </Group>
  )
}
